// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.safetyOrgBtn {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  line-height: 1;\n  font-size: 12px;\n  font-weight: 500;\n  /* padding: 5px 11px; */\n  margin: 0;\n  cursor: pointer;\n  background-color: #dfdddd;\n  outline: none;\n  border: 0px solid rgba(0,0,0,.1);\n  border-radius: 8px;\n  color: #7c7b7b;\n  white-space: nowrap;\n}\n.safetyOrgBtn:hover {\n  background-color: #8b8a8a;\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
